import {
    Create,
    TextInput,
    SimpleForm,
    required,
    SelectInput,
    BooleanInput,
    minValue,
    NumberInput,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';
import { Divider } from '@mui/material';
import { STATUSES, TEST_SERIES_TYPES } from '../../common/constants';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';
import { ProgramAutocomplete } from '../../common/inputs/autoCompleteInputs/ProgramAutoComplete';

const TestSeriesCreate = () => {
    return (
        <Create redirect={'/test-series'}>
            <SimpleForm>
                <FileUpload type="VIDEO_THUMBNAIL" source="image" accept={'image/*'} />
                <TextInput source="title" fullWidth validate={[required()]} />
                <SlugInput source="slug" fullWidth />
                <NumberInput source="DisplayOrder" fullWidth validate={[minValue(1)]} />
                <ProgramAutocomplete alwaysOn />
                <BooleanInput source={'isDemo'} defaultValue={false} />
                <SelectInput
                    source="status"
                    label={'Status'}
                    fullWidth
                    validate={[required()]}
                    choices={STATUSES}
                />
                <SelectInput
                    source="type"
                    label={'Type'}
                    fullWidth
                    defaultValue={'REGULAR'}
                    validate={[required()]}
                    choices={TEST_SERIES_TYPES}
                />
                <TextInput multiline source="textDescription" fullWidth validate={[required()]} />
                <HTMLEditorInput
                    source={'htmlDescription'}
                    fullWidth
                    validate={[required(), validHtml]}
                />
                <Divider />
            </SimpleForm>
        </Create>
    );
};

export default TestSeriesCreate;
